import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

export default function QuestionBank() {
  const dataTree = [
    {
      id: 'QUESTION_AUTO_CODE',
      title: 'Đánh mã câu hỏi',
      url: '/question-bank/question-auto-codes',
      children: [],
    },
    {
      id: 'QUESTION_MANAGEMENT',
      title: 'Quản lý câu hỏi',
      url: '/question-bank/question-management',
      children: [],
    },
  ];

  usePermission(['ROLE_ADMIN', 'ROLE_COMPILER', 'ROLE_MASTER_COMPILER']);

  return <TreeMenu dataTree={dataTree} />;
}
